import React, { useState } from "react";

import ServiceApi from "../services/service.api";
import ContextApp from "../contexts/context.app";
import BasketStorage from "../../ui/views/Basket/Component/BasketStorage";
import ServiceStorage from "../services/service.storage";
import _ from 'lodash';

function ProviderApp({ children }) {

  const [isAuth, setIsAuthState] = useState(ServiceApi.hasToken());
  const [userInfo, setUserInfo] = useState(ServiceStorage.getUserInfo());//{name:"",phone:""}
  const [basketInfo, setbasketInfo] = useState(BasketStorage.getBasket());
  const [basketPersonInfo, setbasketPersonInfo] = useState(BasketStorage.getBasketPerson());
  const [lastUpdate, setLastUpdate] = useState();
  const [selectedCity, setSelectedCity] = useState(() => {
    return (!_.isNil(ServiceStorage.getSelectedCity()) ? ServiceStorage.getSelectedCity()
      : {
        "id": 899,
        "name": "کیش",
        "englishName": "kish"
      })
  });



  const setIsAuth = (value) => {
    if (value) {
      ServiceApi.setToken();
    } else {
      ServiceApi.logout();
    }

    setIsAuthState(value);
  };

  const ctxApp = {
    isAuth,
    setIsAuth,
    userInfo,
    setUserInfo,
    basketInfo,
    setbasketInfo,
    basketPersonInfo,
    setbasketPersonInfo,
    lastUpdate,
    setLastUpdate,
    selectedCity,
    setSelectedCity
  };

  return <ContextApp.Provider value={ctxApp}>{children}</ContextApp.Provider>;
}

export default ProviderApp;
